define("ember-composable-helpers/helpers/find-by", ["exports", "@ember/component/helper", "@ember/utils", "@ember/array", "ember-composable-helpers/utils/as-array"], function (_exports, _helper, _utils, _array, _asArray) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.findBy = findBy;
  function findBy(_ref) {
    let [byPath, value, array] = _ref;
    if ((0, _utils.isEmpty)(byPath)) {
      return [];
    }
    return (0, _array.A)((0, _asArray.default)(array)).findBy(byPath, value);
  }
  var _default = _exports.default = (0, _helper.helper)(findBy);
});